import { Checkbox } from "element-ui";
import FormBase from "./FormBase";
export default {
  name: "AceCheckbox",
  mixins: [Checkbox, FormBase],
  data() {
    return {
      isAuth: true,
    };
  },
  computed: {
    isDisabled() {
      return this.isGroup
        ? this._checkboxGroup.groupDisabled || this._checkboxGroup.disabled || this.disabled || (this.elForm || {}).disabled || this.isLimitDisabled || !this.isAuth
        : this.disabled || (this.elForm || {}).disabled || this.isOperationDisabled() || !this.isAuth;
    },
  },
};
